function copyToClipboard(e) {
  const t = e.target.dataset.copyvalue;
  t && navigator.clipboard.writeText(t);
}
document.querySelectorAll('.card__badge.custom.copyvalue').forEach((e) => {
  e.addEventListener('click', copyToClipboard),
    e.addEventListener('mouseover', (e) => {
      e.target.parentElement.parentElement?.parentElement
        ?.querySelector('.card-media.img-primary')
        ?.classList?.add('hover');
    });
}),
  document.querySelectorAll('.card .card-media.img-primary').forEach((e) => {
    e.addEventListener('mouseover', (e) => {
      e.target.classList.add('hover');
    }),
      e.addEventListener('mouseout', (e) => {
        e.target.classList.remove('hover');
      });
  });
